import { z } from 'zod';

/** Manual time entry against an Item — the timer-based flow (start/stop) takes no body at all. */
export const logWorkSchema = z.object({
  minutes: z.coerce.number().int().min(1, 'Minutes must be at least 1'),
  description: z.string().trim().max(1000).optional().or(z.literal('')),
  date: z.coerce.date().optional(),
});

export type LogWorkInput = z.infer<typeof logWorkSchema>;

export const updateWorklogSchema = logWorkSchema.partial();
export type UpdateWorklogInput = z.infer<typeof updateWorklogSchema>;
